import { useMemo } from 'react';
import { type AverageMileageSettingsPayload } from '../../../../../../api/types';

const useAverageMileages = (averageMileageSettings: AverageMileageSettingsPayload): number[] =>
    useMemo(() => {
        if (!averageMileageSettings) {
            return [];
        }

        const { min: minMileage, max: maxMileage, step: mileageStep } = averageMileageSettings;
        if (!Number.isFinite(minMileage) || !Number.isFinite(maxMileage) || !Number.isFinite(mileageStep)) {
            return [];
        }

        const results = [];
        for (let mileage = minMileage; mileage <= maxMileage; mileage += mileageStep) {
            results.push(mileage);
        }

        return results;
    }, [averageMileageSettings]);

export default useAverageMileages;
